const LABELS = {
  ru: {
    pageTitle: "Здравоохранение",
    // тулбары
    period: "Период",
    year: "Год",
    quarter: "Квартал",
    dynamics: "Динамика",
    from: "От",
    to: "До",
    reportPeriod: "Отчётный период",
    // легенда
    legendDone: "Выполнено (цель достигнута)",
    legendNotDone: "Не выполнено",
    legendFact: "Факт",
    legendPlan: "План",
    legendArrow:
      "Стрелка ↑/↓ — факт выше/ниже плана; результат показывает цвет, а не стрелка",
    legendQuarterNote: "факт сравнивается с годовым планом",
    // KPI
    statPanel: "Статистическая панель",
    forPeriod: "на период",
    totalIndicators: "Всего показателей",
    done: "Выполнено",
    notDone: "Не выполнено",
    completion: "Выполнение",
    noDataCount: "нет данных",
    // карточки
    indicatorsTitle: "Индикаторы здравоохранения",
    bigNumberIs: "крупное число",
    chartIs: "график — динамика",
    plan: "План",
    fact: "Факт",
    noData: "Нет данных",
    lowerBetter: "↓ ниже плана — лучше",
    higherBetter: "↑ выше плана — лучше",
    // диаграмма
    planFactTitle: "План и факт по показателям",
    factColorNote:
      "Цвет столбца «Факт» = статус выполнения (с учётом направления показателя)",
    // таблица
    tableTitle: "Сводная таблица",
    colIndicator: "Показатель",
    colPlan: "План",
    colFact: "Факт",
    colAssessment: "Оценка",
    colStatus: "Статус",
    // состояния
    loadError: "Не удалось загрузить данные. Обновите страницу.",
    noDataPeriod: "Нет данных за период",
  },
  kz: {
    pageTitle: "Денсаулық сақтау",
    period: "Кезең",
    year: "Жыл",
    quarter: "Тоқсан",
    dynamics: "Динамика",
    from: "Бастап",
    to: "Дейін",
    reportPeriod: "Есептік кезең",
    legendDone: "Орындалды (мақсатқа қол жеткізілді)",
    legendNotDone: "Орындалмады",
    legendArrow:
      "↑/↓ көрсеткісі — факт жоспардан жоғары/төмен; нәтижені көрсеткі емес, түс көрсетеді",
    legendQuarterNote: "факт жылдық жоспармен салыстырылады",
    statPanel: "Статистикалық панель",
    forPeriod: "кезеңге",
    totalIndicators: "Барлық көрсеткіштер",
    done: "Орындалды",
    notDone: "Орындалмады",
    completion: "Орындалу",
    noDataCount: "деректер жоқ",
    indicatorsTitle: "Денсаулық сақтау индикаторлары",
    bigNumberIs: "ірі сан",
    chartIs: "график — динамика",
    plan: "Жоспар",
    fact: "Факт",
    noData: "Деректер жоқ",
    lowerBetter: "↓ жоспардан төмен — жақсы",
    higherBetter: "↑ жоспардан жоғары — жақсы",
    planFactTitle: "Көрсеткіштер бойынша жоспар мен факт",
    factColorNote:
      "«Факт» бағанының түсі = орындалу мәртебесі (көрсеткіш бағытын ескере отырып)",
    tableTitle: "Жиынтық кесте",
    colIndicator: "Көрсеткіш",
    colPlan: "Жоспар",
    colFact: "Факт",
    colAssessment: "Бағалау",
    colStatus: "Мәртебе",
    loadError: "Деректерді жүктеу мүмкін болмады. Бетті жаңартыңыз.",
    noDataPeriod: "Кезең бойынша деректер жоқ",
  },
};

export const getLabels = (lang) => LABELS[lang] || LABELS.ru;

const ROMAN = ["I", "II", "III", "IV"];

export const periodLabel = (p, lang) =>
  (lang === "kz" ? p.label_kz : p.label_ru) || p.key;

export const periodShort = (p) =>
  p.type === "quarter"
    ? `${ROMAN[p.quarter - 1]}·${String(p.year).slice(2)}`
    : String(p.year);

export const formatValue = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 }).format(n);
};

export const arrowFor = (fact, plan) => {
  if (
    fact === null ||
    fact === undefined ||
    plan === null ||
    plan === undefined
  )
    return "";
  if (fact > plan) return "↑";
  if (fact < plan) return "↓";
  return "→";
};
